import React, { useEffect, useState } from "react";
import { getCompanyInfo, getQuickLinks, getSocialLinks } from "../api/companyService";
import { sleep } from "../utils/sleep";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import * as Icons from "react-icons/fa";

const Footer = () => {
  const [quickLinks, setQuickLinks] = useState([]);
  const [quickLinkLoading, setQuickLinkLoading] = useState(true);
  const [quickLinkError, setQuickLinkError] = useState(null);
  
  const [companyInfo, setCompanyInfo] = useState(null);
  const [companyInfoLoading, setCompanyInfoLoading] = useState(true);
  const [companyInfoError, setCompanyInfoError] = useState(null);

  const [socialLinks, setSocialLinks] = useState([]);
  const [socialLinksLoading, setSocialLinksLoading] = useState(true);
  const [socialLinksError, setSocialLinksError] = useState(null);

  const fallBackQuickLinks = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Contact", path: "/contact" },
  ];
  
  const fallBackSocialLinks = [
  { platform: "facebook", icon:"FaFacebookF", url: "https://www.facebook.com/softition" },
  { platform: "twitter", icon:"FaTwitter", url: "https://x.com/softition" },
  { platform: "linkedin", icon:"FaLinkedinIn", url: "https://www.linkedin.com/company/softition/" },
  { platform: "instagram", icon:"FaInstagram", url: "https://www.instagram.com/softitionsolutions/" },
];
  
  useEffect(() => {
    const fetchQuickLinks = async () => {
      try {
        //await sleep(2000);
        const data = await getQuickLinks();
        setQuickLinks(data);
      } catch (err) {
        setQuickLinkError("Failed to load quick links.");
      } finally {
        setQuickLinkLoading(false);
      }
    };
  
    const fetchCompanyInfo = async () => {
      try {
        //await sleep(1000);
        const data = await getCompanyInfo(); // new API
        setCompanyInfo(data);
      } catch (err) {
        setCompanyInfoError("Failed to load company info.");
      } finally {
        setCompanyInfoLoading(false);
      }
    };

    const fetchSocialLinks = async () => {
      try {
        //await sleep(1000);
        const data = await getSocialLinks(); // new API
        setSocialLinks(data);
      } catch (err) {
        setSocialLinksError("Failed to load company info.");
      } finally {
        setSocialLinksLoading(false);
      }
    };
  
    fetchQuickLinks();
    fetchCompanyInfo();
    fetchSocialLinks();
  }, []);
  return (
    <footer className="bg-secondary-color text-light pt-5">
      <div className="container">
        <div className="row g-4">
          {/* Brand Section */}
          {(companyInfoLoading || companyInfoError) ? (
            <div className="col-lg-3 col-md-6">
                      <h3 className="placeholder-glow">
                        <span className="placeholder col-6 nav-placeholder"> &nbsp;</span>
              </h3>
              <p className="placeholder-glow">
                        <span className="placeholder col-6 nav-placeholder"> &nbsp;</span>
              </p>
              </div>
          ) : (
              <div className="col-lg-3 col-md-6">
            <h3 className="fw-bold text-primary-color">{companyInfo?companyInfo.name:''}</h3>
                <p className="small text-color">{companyInfo ? companyInfo.shortDesc : ''}</p>
                </div>
                    )}
          

          {/* Quick Links */}
          <div className="col-lg-2 col-md-6">
            <h6 className="fw-bold text-white mb-3">Quick Links</h6>
            <ul className="list-unstyled small">
              {((quickLinkError || quickLinkLoading)? fallBackQuickLinks : quickLinks).map((link, idx) => {
              return (
                <li className="nav-item" key={idx}>
                    {(quickLinkLoading || quickLinkError) ? (
                      <span className="placeholder-glow">
                        <span className="placeholder col-6 nav-placeholder"> &nbsp;</span>
                      </span>
                  ) : (
                      <li><a href={link.path} className="text-accent-footer text-decoration-none">{link.label}</a></li>
                    )}
                  
                </li>
              );
            })}
            </ul>
          </div>

          {/* Contact Info */}
          {(companyInfoLoading || companyInfoError) ? (
            <div className="col-lg-4 col-md-6">
              <h6 className="fw-bold text-white mb-3">Contact</h6>
                      <p className="placeholder-glow">
                        <span className="placeholder col-6 nav-placeholder"> &nbsp;</span>
              </p>
              <p className="placeholder-glow">
                        <span className="placeholder col-6 nav-placeholder"> &nbsp;</span>
              </p>
              <p className="placeholder-glow">
                        <span className="placeholder col-6 nav-placeholder"> &nbsp;</span>
              </p>
              </div>
          ) : (
              <div className="col-lg-4 col-md-6">
            <h6 className="fw-bold text-white mb-3">Contact</h6>
            <p className="small mb-2"><FaMapMarkerAlt className="me-2 text-accent-footer" /> { companyInfo? companyInfo.contact.address:''}</p>
            <p className="small mb-2"><FaPhoneAlt className="me-2 text-accent-footer" /> { companyInfo? companyInfo.contact.phone:''}</p>
            <p className="small"><FaEnvelope className="me-2 text-accent-footer" /> { companyInfo? companyInfo.contact.email:''}</p>
          </div>
          )}
          
          {/* Social Media */}
          <div className="col-lg-3 col-md-6">
            <h6 className="fw-bold text-white mb-3">Follow Us</h6>
            <div className="d-flex gap-3">
              {((socialLinksError || socialLinksLoading) ? fallBackSocialLinks : socialLinks).map((link, idx) => {
               const Icon = Icons[link.icon]; // dynamically select icon  
              return (
                <>
                    {(socialLinksLoading || socialLinksError) ? (
                      <div className="placeholder-glow me-2 social-circle-footer"></div>
                  ) : (
                     <a key={idx} href={link.url} className="social-circle-footer" target="_blank" rel="noreferrer">
                      {Icon ? <Icon /> : null}
                    </a>
                    )}
                  
                </>
              );
            })}
            </div>
          </div>

        </div>

        {/* Bottom Strip */}
        {(companyInfoLoading || companyInfoError) ? (
            <p className="placeholder-glow  text-center">
                <span className="placeholder col-6 nav-placeholder"> &nbsp;</span>
              </p>
          ) : (
             <div className="text-center mt-4 border-top border-secondary pt-3 small">
          { companyInfo? companyInfo.footerText:''}
        </div>
        )}
      </div>
    </footer>
  );
};

export default Footer;
